<template>
	<c-dialog ref="dialog" title="销售订单详情" mode="slide" width="100vw-300" enable-flex mask-close :button="false">
		<template #head>
			<div v-if="detailData.order_code" class="m-detail-tag flex-center-cross">
				<label>{{detailData.order_code}}</label>
				<c-state dict="schedulingStateDic" tag :value="detailData.scheduling_state"></c-state>
				<c-state type="expectedDate" tag :value="detailData.expected_date"></c-state>
			</div>
		</template>
		
		<module>
			<module-col size="350">
				<c-detail class="m-detail-form">
					<c-detail-item label="订单二维码">
						<c-qrcode :value="detailData.h5_web" size="100"></c-qrcode>
					</c-detail-item>
					<c-detail-item label="客户名称">
						{{detailData.customer_name}}
					</c-detail-item>
					<c-detail-item label="产品金额">
						{{detailData.product_money}}
					</c-detail-item>
					<c-detail-item label="生产进度(%)" v-if="detailData.scheduling_state == 1">
						<c-progress :rate="[detailData.task_fine_count, detailData.task_plan_count||1]" :color="((detailData.task_fine_count/detailData.task_plan_count)>=1||detailData.task_plan_count==0) ?'green':'blue'"></c-progress>
					</c-detail-item>
					<c-detail-item label="要求交货时间">
						{{detailData.plan_delivery_date}}
					</c-detail-item>
					<c-detail-item label="交货进度">
						{{detailData.deliver_count}}/{{detailData.main_product_count}}
					</c-detail-item>
					<c-detail-item label="交货进度(%)">
						<c-progress :rate="[detailData.deliver_count, detailData.main_product_count]" :color="((detailData.deliver_count/detailData.main_product_count)>=1||detailData.deliver_count==0) ?'green':'blue'"></c-progress>
					</c-detail-item>
					<c-detail-item label="订单完成时间">
						{{detailData.finish_date}}
					</c-detail-item>
					<c-detail-item label="创建人">
						{{detailData.create_user_realname}}
					</c-detail-item>
					<c-detail-item label="创建时间" colspan="2">
						{{detailData.create_date}}
					</c-detail-item>
					<custom-detail work-type="1" :data="detailData.customFieldValues"></custom-detail>
				</c-detail>
			</module-col>

			<module-col tab-type="border-tab">
				<module-tab name="订单信息">
					<div class="m-detail-box">
						<c-title>产品明细</c-title>
						<custom-table ref="productTable" view-id="20001" readonly>
							<template #aux_unit_count_tip="{data}">
								<c-tooltip tip="提示" width="360" align="end">
									<template #tip>
										<p>单位转换倍率说明：</p>
										<p>单位换算率为产品主/辅单位之间的转换倍率，计算公式如下：</p>
										<p>销售数量（辅单位）* 换算率 = 产品数量（主单位）</p>
										<p>如：1（kg） * 1000 = 1000（g）</p>
										<p>换算率修改后系统会自动计算产品数量</p>
									</template>
								</c-tooltip>
							</template>
							
							<!--产品来源-->
							<template #product_source="{data}">
								<c-state dict="productSourceName" :value="data.product_source"></c-state>
							</template>
							
							<!--产品类型-->
							<template #product_type="{data}">
								<c-state dict="productTypeName" :value="data.product_type"></c-state>
							</template>
						</custom-table>

						<c-title>发货记录</c-title>
						<custom-table ref="deliverTable" view-id="20002" readonly>
							<template #aux_unit_count_tip="{data}">
								<c-tooltip tip="提示" width="360" align="end">
									<template #tip>
										<p>单位转换倍率说明：</p>
										<p>单位换算率为产品主/辅单位之间的转换倍率，计算公式如下：</p>
										<p>发货数量（辅单位）* 换算率 = 发货产品数量（主单位）</p>
										<p>如：1（kg） * 1000 = 1000（g）</p>
										<p>换算率修改后系统会自动计算发货产品数量</p>
									</template>
								</c-tooltip>
							</template>
						</custom-table>

						<c-title>已排产产品</c-title>
						<custom-table ref="workTable" view-id="20003" readonly>
							<c-table-column
								type="tree"
								label="工单层级"
								width="300"
								name="childProduct"
								level-limit="5"
								:leaf-node="({data}) => !data.childProduct"
							>
								<template #default="{data}">
									{{data.product_name}}
								</template>
							</c-table-column>
							
							<!--产品来源-->
							<template #product_source="{data}">
								<c-state dict="productSourceName" :value="data.product_source"></c-state>
							</template>
							
							<!--产品类型-->
							<template #product_type="{data}">
								<c-state dict="productTypeName" :value="data.product_type"></c-state>
							</template>
							
							<!--工单进度-->
							<template #process_rate="{data}">
								<process-rate :key="data._timestamp" :id="data.id"></process-rate>
							</template>
							
							<!--工单进度%-->
							<template #work_progress="{data}">
								<c-progress :rate="[data.ok_count, data.plan_count]" :color="((data.ok_count/data.plan_count)>=1||data.plan_count==0) ?'green':'blue'"></c-progress>
							</template>
							
							<!--工单明细进度%-->
							<template #work_detail_progress="{data}">
								<c-progress :rate="[data.task_fine_count, data.task_plan_count||1]" :color="((data.task_fine_count/data.task_plan_count)>=1||data.task_plan_count==0) ?'green':'blue'"></c-progress>
							</template>
							
							<!--计划时间-->
							<template #plan_date="{data}">
								{{data.plan_start_date}} - {{data.plan_end_date}}
							</template>
							
							<!--工单状态-->
							<template #work_state="{data}">
								<c-state dict="orderStateDic" tag :value="data.work_state"></c-state>
							</template>
							
							<!--优先级-->
							<template #priority="{data}">
								<c-state dict="priorityDic" tag :value="data.priority"></c-state>
							</template>
							
							<!--工期状态-->
							<template #plan_date_state="{data}">
								<c-state type="expectedDate" :value="data.expected_date"></c-state>
							</template>
						</custom-table>
						
						<c-title>关联采购产品</c-title>
						<custom-table ref="purchaseTable" view-id="20018" readonly>
							
						</custom-table>
					</div>
				</module-tab>
			</module-col>
		</module>
	</c-dialog>
</template>

<script>
	export default {
		name: 'orderDetail',

		props: {
			id: [String, Number]
		},
		
		data() {
			return {
				detailData: {}
			}
		},

		methods: {
			open() {
				this.request({
					url: '/order/overview',
					data: {
						id: this.id
					},
					loading: true,
					success: data => {
						this.detailData = data.detailInfo;
						this.$refs.productTable.init();
						this.$refs.deliverTable.init();
						this.$refs.workTable.init();
						this.$refs.purchaseTable.init();
						this.$refs.productTable.$refs.list.setData(data.productList);
						this.$refs.deliverTable.$refs.list.setData(data.deliverList);
						this.$refs.workTable.$refs.list.setData(data.workList);
						this.$refs.purchaseTable.$refs.list.setData(data.purchaseList);
						this.$refs.dialog.open();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>